import React, { FunctionComponent } from 'react'

import { FaceIdPromptIconProps } from './FaceIdPromptIconSvg'
import { withSuspense } from '../../utils/withSuspense'
const FaceIdPromptIconSvg = withSuspense({
  component: React.lazy(() => import('./FaceIdPromptIconSvg')),
})

/**
 * Face ID icon (shown on biometrics prompt screen on onboarding)
 */
export const FaceIdPromptIcon: FunctionComponent<FaceIdPromptIconProps> = ({ width, height }) => {
  return <FaceIdPromptIconSvg width={width} height={height} />
}
